import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

import { RideCheckbox, RideGlLockSolid } from '@rimac-seguros/ride-system-components';
import { Checkout } from 'checkout-component-react';

import { useAppContext } from '../../../AppProvider';
import { checkoutVisa, payformText } from '../../../utils/constants';
import { capitalize } from '../../../utils/helpers';
import { decryptCredentials } from '../../../utils/cifrate';
import { getBeginningValidityFormat } from '../../../utils/functions';
import {
  sendEmailPaymentConfirmation,
  welcomeNotification,
  registerLead,
  sendRequestToEmision,
} from '../../../services/clientServices';
import ModalPortal from '../../../components/molecules/rbrModal/ModalPortal';
import { PaymentPageModalBody } from '../../../components/organisms';
import { getTagPayment } from '../../../utils/analytics';
import { getValueOfForm } from '../../../auditory/utils/functions';

import { callAnalyticsError, callAnalyticsMetadata } from '../../../utils/tag.utils';
import { INACTIVE_CHECKOUT_CODES } from '../constants';
import { ENDPOINT_APP_URL_CHECKOUT } from '../../../utils/constants/api-constants';
import { Monitoring } from '../../../auditory/utils/monitoring';
import { useHistory } from '../../../hooks/useHistory';
import {
  outAuditory,
  useAuditory,
  withSuccessPayment,
} from '../../../auditory/provider/hooks';
import { logsAuditory } from '../../../auditory/provider/actions';

const Payform = ({ updateSessionToken, isTermsChecked, setIsTermsChecked }) => {
  const [visa] = useState('');
  const [tool] = useState('');
  // eslint-disable-next-line
  // eslint-disable-next-line
  const [nombre] = useState('');
  const [apellido] = useState('');
  const [email] = useState('');
  const [modalPayment, setModalPayment] = useState(false);
  const [modalTimeout, setModalTimeout] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  let retrys = 0;

  const { navigate } = useHistory();

  const { dispatch: dispatchAuditory } = useAuditory();

  const {
    dispatch,
    state:
    {
      sessionId,
      idQuote,
      planSelected: { price, priceDiscount, descripcion },
      leadData,
      planSelected,
      client,
      client: { correo },
    },
  } = useAppContext();

  const priceFinal = priceDiscount ?? price;

  const getVariant = () => {
    const coveragesInline = planSelected.completeCoverages.map((item) => item.description).join(' - ');
    const variant = `${planSelected.name} - ${priceFinal} - ${coveragesInline}`;
    return variant;
  };

  const getTemplateEmail = async () => {
    const templateHtml = await fetch('/ventadigital/salflex/assets/mailing/mail-compra-exitosa.html');
    const templateText = await templateHtml.text();
    return templateText;
  };

  const padTo2Digits = (num) => num.toString().padStart(2, '0');

  const formatDate = (date) => [padTo2Digits(date.getDate()), padTo2Digits(date.getMonth() + 1), date.getFullYear()].join('/');

  const getDataToReplace = async (dataPayment) => {
    const urlBase = (window.location.hostname === 'www.rimac.com') ? 'https://www.rimac.com' : 'https://d27e5v3xq6qje3.cloudfront.net';

    return {
      NAME: capitalize(client.nombres),
      TITULAR: capitalize(client.apellidoPaterno),
      NAME_PLAN: descripcion,
      LOGO: `<img src="${urlBase}/ventadigital/salflex/assets/mailing/logo-com.png"/>`,
      ILU_HERO_MOB: `<img class="ilu-hero-mob" src="${urlBase}/ventadigital/salflex/assets/mailing/ilu-hero-email-mob.png" alt="ilu hero" style="margin-bottom: 48px;"/>`,
      ILU_HERO_DESK: `<img class="ilu-hero-desk" src="${urlBase}/ventadigital/salflex/assets/mailing/ilu-hero-email-desk.png" alt="ilu hero" style="margin-bottom: 48px;"/>`,
      AMOUNT_TO_PAY_DEC: (priceFinal).toFixed(2),
      EMAIL: correo,
      FECHA_COMPRA: formatDate(new Date()),
      NRO_PEDIDO: dataPayment?.nroPedido,
      NRO_TARJETA: dataPayment?.nroTarjeta,
      ANIO: new Date().getFullYear(),
      ICON_PAY: `<img src="${urlBase}/ventadigital/salflex/assets/mailing/icon-pay.png" alt="Icon pay" />`,
      STEP_1: `<img src="${urlBase}/ventadigital/salflex/assets/mailing/step1.png" alt="step" />`,
      STEP_2: `<img src="${urlBase}/ventadigital/salflex/assets/mailing/step2.png" alt="step" />`,
      ICON_HOSPITAL: `<img src="${urlBase}/ventadigital/salflex/assets/mailing/icon-hospital.png" alt="hospital" />`,
      ICON_BAG: `<img src="${urlBase}/ventadigital/salflex/assets/mailing/icon-bag.png" alt="bag" />`,
      ICON_ASSURANCE: `<img src="${urlBase}/ventadigital/salflex/assets/mailing/icon-assurance.png" alt="assurance" />`,
      LOGO_FOOTER: `<img  src="${urlBase}/ventadigital/salflex/assets/mailing/logo-footer-new.png" alt="Logo footer" />`,
      LOGO_FACEBOOK: `<img  src="${urlBase}/ventadigital/salflex/assets/mailing/logo-facebook.png" alt="Logo facebook" />`,
      LOGO_LINKEDIN: `<img style="padding-left: 8px;" src="${urlBase}/ventadigital/salflex/assets/mailing/logo-linkedin.png" alt="Logo linkedin" />`,
      LOGO_TWITTER: `<img  style="padding-left: 8px;" src="${urlBase}/ventadigital/salflex/assets/mailing/logo-twitter.png" alt="Logo twitter" />`,
      LOGO_YOUTUBE: `<img  style="padding-left: 8px;" src="${urlBase}/ventadigital/salflex/assets/mailing/logo-youtube.png" alt="Logo youtube" />`,
      GL_HEART: `<img  src="${urlBase}/ventadigital/salflex/assets/mailing/gl_heart.png" alt="icon" />`,
      GL_WHATSAPP: `<img  src="${urlBase}/ventadigital/salflex/assets/mailing/gl-whatsapp.png" alt="icon" />`,
      GL_PHONE: `<img  src="${urlBase}/ventadigital/salflex/assets/mailing/gl-phone.png" alt="icon" />`,
      GL_SHIELD: `<img  src="${urlBase}/ventadigital/salflex/assets/mailing/gl-shield.png" alt="icon" />`,
      GL_MAIL: `<img  src="${urlBase}/ventadigital/salflex/assets/mailing/gl-mail.png" alt="icon" />`,
      ICON_ANDROID: `<img  src="${urlBase}/ventadigital/salflex/assets/mailing/store-play-store.png" alt="android" />`,
      ICON_IOS: `<img  src="${urlBase}/ventadigital/salflex/assets/mailing/store-ios.png" alt="ios" />`,
      ICON_HUAWEI: `<img  src="${urlBase}/ventadigital/salflex/assets/mailing/store-huawei.png" alt="huawei" />`,
    };
  };

  const sendEmailSuccessPurcharse = async (dataPayment, paymentEmail) => {
    const html = await getTemplateEmail();
    const dataToReplace = await getDataToReplace(dataPayment);
    const requestEmail = {
      de: 'RIMAC Digital <rimacdigital@rimac.com.pe>',
      para: [correo],
      asunto: 'Compra exitosa',
      template: html,
    };

    await sendEmailPaymentConfirmation({ requestEmail, dataToReplace });

    const requestEmision = {
      ideTransaccion: idQuote,
      producto: 'ami',
      origen: sessionStorage.getItem('canal') || 'web',
      correoPago: paymentEmail,
      tercero: {
        tipoDocumento: client.tipoDocumento.toString() || '2',
        numeroDocumento: client.numeroDocumento,
        correo: client.correo,
        idLead: leadData?.idLead,
      },
    };
    await sendRequestToEmision(requestEmision);
  };

  const getRequestNotify = () => {
    const fechaInicioVigencia = getBeginningValidityFormat();
    return {
      tipDocumento: client?.tipoDocumento?.toString(),
      numDocumento: client?.numeroDocumento,
      nombre: client?.nombres,
      apePaterno: client?.apellidoPaterno,
      apeMaterno: client?.apellidoMaterno,
      mail: client?.correo,
      celular: client?.telefono,
      fecInicioVigencia: fechaInicioVigencia,
    };
  };

  /* eslint-disable */
  const checkoutRpta = (response) => {
    const localMail = getValueOfForm('email') || null;
    const checkoutError = sessionStorage.getItem('checkoutError');
    const retriesRender = sessionStorage.getItem('retriesRender');
    const requestLog = getRequestNotify();

    if (checkoutError === 'checkoutError') {
      return;
    }

    if (response.data) {
      const checkoutSuccess = localStorage.getItem("checkoutSuccess");
      if (checkoutSuccess) {
        window.checkoutRpta = () => { console.log("Función vacía checkout...") };
        return;
      }
      const request = leadData;
      request.finalizado = 6;

      registerLead(request)
        .then(() => {
          dispatch({ type: 'ADD_LEAD_DATA', payload: request });
        }).catch((e) => console.log('fallo => ', e))
      localStorage.setItem('paymentSuccesss', true);
      /* send Email Payment Confirmation */
      const { orden, tarjeta } = response.data;
      const dataPayment = {
        nroPedido: orden.numeroPedido,
        nroTarjeta: tarjeta.numeroTarjeta,
      };
      sendEmailSuccessPurcharse(dataPayment, localMail);
      getTagPayment(idQuote, priceFinal, String(planSelected.idePlan), getVariant());
      const fechaInicioVigencia = getBeginningValidityFormat();
      welcomeNotification({
        tipDocumento: client.tipoDocumento.toString(),
        numDocumento: client.numeroDocumento,
        nombre: client.nombres,
        apePaterno: client.apellidoPaterno,
        apeMaterno: client.apellidoMaterno,
        mail: client.correo,
        celular: client.telefono,
        fecInicioVigencia: fechaInicioVigencia,
      }).then((answer) => console.log('notificar:', answer))
        .catch((error) => console.log(error));
      withSuccessPayment({
        urlServicio: ENDPOINT_APP_URL_CHECKOUT,
        urlCliente: window.location?.href,
        respuestaExito: JSON.stringify(response.data),
        request: JSON.stringify({
          ...requestLog,
          checkout: {
            correo: localMail,
          },
        }),
      });
      localStorage.setItem("checkoutSuccess", true);
      navigate('/comprar/seguro-salud-flexible/gracias');
    } else if (response.error) {

      console.log('>>> response.error', response.error);

      const errorCode = response?.error?.codigo
        ? response?.error?.codigo
        : response?.error?.resultado?.codigo;
      const errorMessage = response?.error?.mensaje
        ? response?.error?.mensaje
        : response?.error?.resultado?.mensaje;

      const isInactiveError = INACTIVE_CHECKOUT_CODES.find((element) => {
        return errorCode == element;
      });

      if (Number(retriesRender) >= 4 && isInactiveError) {
        setModalTimeout(true);

        callAnalyticsMetadata('Endpoint', ENDPOINT_APP_URL_CHECKOUT);
        callAnalyticsError({
          code: errorCode || 'Código generico',
          message: errorMessage || 'Error generico de Checkout.js',
          endpoint: ENDPOINT_APP_URL_CHECKOUT,
        });

        return;
      }

      if (isInactiveError && updateSessionToken) {
        updateSessionToken(errorCode, errorMessage);
      }

      callAnalyticsMetadata('Endpoint', ENDPOINT_APP_URL_CHECKOUT);
      callAnalyticsError({
        code: errorCode || 'Código generico',
        message: errorMessage || 'Error generico de Checkout.js',
        endpoint: ENDPOINT_APP_URL_CHECKOUT,
      });
      
      if (window?.ineum) {
        window.ineum('reportError', response.error, {
          componentStack: 'error checkout',
          meta: {
            actionName: 'checkoutRpta',
            error: JSON.stringify(response.error),
          },
        });
      }
      window.intentos++;
      retrys = window.intentos;
      if (retrys === 3) {
        setTimeout(() => {
          Monitoring.reportError({
            origin: 'Payform',
            auditoryId: window.idAuditoria,
            customError: {
              error: {
                code: 'R0032-ATTEMPS',
                message:
                  '3 reintentos. Oh, no! Ocurrió un error técnico que no deja procesar tu pago',
              },
              selector: outAuditory.selector,
            },
            actionApi: 'checkoutAPI',
            actionName: 'checkout',
          });
          logsAuditory(dispatchAuditory, outAuditory?.state?.auditoria, {
            paso: 2,
            pasoDescripcion: 'PASO_PAGO',
            urlServicio: ENDPOINT_APP_URL_CHECKOUT,
            urlCliente: window.location?.href,
            respuestaError:
              '3 reintentos. Oh, no! Ocurrió un error técnico que no deja procesar tu pago',
            request: JSON.stringify({
              ...requestLog,
              checkout: {
                correo: localMail,
              },
            }),
          });
        }, 0);
        return navigate('/comprar/seguro-salud-flexible/pago/error');
      } else {
        if (!isInactiveError) {
          setModalPayment(true);
        }
      }
    }
  };

  const applyNumEmpty = (numId) => {
    return (
      numId !== 0 &&
      numId !== '' &&
      numId !== null &&
      numId !== undefined
    ) ? numId : undefined;
  };

  function abrirtool() {
    console.log('abrir tool');
  }

  function cerrartool() {
    console.log('abrir tool');
  }

  function handleInitCheckout() {
    window.CheckoutJS.publicKey = decryptCredentials(process.env.REACT_APP_KEY_CHECKOUT_VISA);
    window.CheckoutJS.sessionToken = sessionId;
    window.CheckoutJS.settings({
      reference: {
        numId: applyNumEmpty(client.tercero),
        codigoProducto: '2',
        ideTransaccion: idQuote,
      },
      operation: checkoutVisa.operacion,
      currency: checkoutVisa.moneda,
      amount: String(priceFinal),
      callback: checkoutVisa.callback,
      name: nombre,
      lastName: apellido,
      email,
      runtime: checkoutVisa.runtime,
      subscription: true,
      imgLoading: checkoutVisa.imgLoading,
      attributes: [checkoutVisa.requerido],
    });

    window.checkoutRpta = checkoutRpta;
    setIsLoading(false);
  }

  useLayoutEffect(() => {
    if (sessionId) {
      handleInitCheckout();
      window.intentos = 0;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  return isLoading ? null : (
    <div className="payment">
      <div className="card-data content-payform">
        <p className="card-data-title">Ingresa los datos de tu tarjeta</p>
        <div className="advice">
          <RideGlLockSolid size="medium" />
          <p className="advice__subtitle">Garantizamos una compra segura.</p>
        </div>
        <form action="" className="tarjeta">
          <div className="input-field creditcard">
            <p className="icon-card" />
            <div className="campo">
              <Checkout type="card" />
              <label className="input-placeholder">Número de tarjeta</label>
            </div>
            <div className={`imagen-tarjeta ${visa}`} />
          </div>
          <div className="input-field fecha active">
            <Checkout type="expiry" />
            <label className="input-placeholder">MM/AA</label>
          </div>
          <div className="input-field cvv">
            <Checkout type="cvv" />
            <label className="input-placeholder">CCV</label>
            <i className="icon-tooltip" onClick={abrirtool} />

            <div className={`tooltip ${tool}`}>
              <i className="icon-cancel" onClick={cerrartool} />
              <img src="static/images/cvv.png" alt="" />
              <h5>CÓDIGO CVV</h5>
              <p>
                {payformText.subtitle}
              </p>
            </div>
          </div>
          <div className="input-field nombre">
            <Checkout type="name" />
            <label className="input-placeholder">Nombre</label>
          </div>

          <div className="input-field apellido">
            <Checkout type="lastName" />
            <label className="input-placeholder">Apellido</label>
          </div>
          <div className="input-field email">
            <Checkout type="email" />
            <label className="input-placeholder">Correo electrónico</label>
          </div>
          <span id="validMessage" className="show-error" />
          <div className="mb-16 wrapper-field field-checkbox">
            <RideCheckbox
              size="small"
              checked={isTermsChecked}
              onClick={() => setIsTermsChecked(!isTermsChecked)}
            />
            <label htmlFor="autoChargeCheckbox">
              Al pagar autorizo el cargo automático a la tarjeta registrada para este pago.
            </label>
          </div>
        </form>
      </div>

      <ModalPortal
        isOpen={modalPayment || modalTimeout}
        callbackClose={() => setModalPayment(!modalPayment)}
        extraClass="modal-pol-com modal-overflow-old modal-payment"
      >
        <PaymentPageModalBody onClose={() => {
          if (modalTimeout) {
            setModalTimeout(false);
            setModalPayment(false);
            window.location.href = '/comprar/seguro-salud-flexible';
          } else {
            setModalPayment(!modalPayment)
          }
        }} isTimeout={modalTimeout} />
      </ModalPortal>
    </div>
  );
};

Payform.propTypes = {
  updateSessionToken: PropTypes.func.isRequired,
  isTermsChecked: PropTypes.bool.isRequired,
  setIsTermsChecked: PropTypes.func.isRequired,
};

export default Payform;
